module.exports = __webpack_public_path__ + "img/expired.f4d9b834.svg";